module.exports = __webpack_public_path__ + "static/media/01-02.44c2df56.mp3";